import { JWT_KEY } from "Auth/Models/AuthConstants";
import type { ApiQueryMeta } from "Infrastructure/Api/ApiUtils";
import {
	getApiV1AuthUserinfoQueryKey,
	postApiV1AuthSignInMutation,
} from "Infrastructure/Api/generated/@tanstack/react-query.gen";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useSignInMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		...postApiV1AuthSignInMutation(),
		// Sign-in errors are rendered inline by SignInForm via useHandleServerError,
		// so suppress the global toast to avoid double-display.
		meta: { showError: false } satisfies ApiQueryMeta,
		onSuccess: (data) => {
			localStorage.setItem(JWT_KEY, `Bearer ${data.userInfo.token}`);
			queryClient.invalidateQueries({
				queryKey: getApiV1AuthUserinfoQueryKey(),
			});
		},
	});
}
